import type { BuildInfo } from "../../lib/build-info";

/**
 * The rows of the about dialog (CD-010 / LP-032: "Versions- und Buildnummer,
 * Datum, Quellstand (Tag / Commit)"). Pure, so the wording of a local build
 * - which has no build number, commit, tag or date - is pinned by a test.
 *
 * *Build* is the publish run's number (CD-018), not `sha-` plus the commit:
 * that only repeated *Quellstand*, while two builds of one commit - a re-run,
 * a review build - differ by their run.
 */
export interface BuildRow {
  key: "version" | "build" | "builtAt" | "source";
  value: string;
}

export function buildRows(
  info: BuildInfo,
  formatDate: (iso: string) => string,
  localLabel: string,
): BuildRow[] {
  return [
    { key: "version", value: info.version },
    { key: "build", value: info.build ? `#${info.build}` : localLabel },
    { key: "builtAt", value: info.builtAt ? formatDate(info.builtAt) : localLabel },
    {
      key: "source",
      value: [info.tag, info.commit].filter((part): part is string => Boolean(part)).join(" / ") || localLabel,
    },
  ];
}

export interface BuildBlock {
  title: string;
  rows: { label: string; value: string }[];
}

/**
 * What the dialog's copy button puts on the clipboard (CD-017): the title,
 * then each block under its own heading, one `Label: Wert` line per row - so
 * a report quotes the exact build instead of a retyped one.
 */
export function buildText(title: string, blocks: BuildBlock[]): string {
  const lines = [title];
  for (const block of blocks) {
    lines.push("", block.title, ...block.rows.map((row) => `${row.label}: ${row.value}`));
  }
  return lines.join("\n");
}
